import ImageSection from 'src/components/ui/GlobalComponents/ImageSection/ImageSection';
import { useSmartWord } from 'src/hook/global/useSmartWord';
import { Challenge } from 'src/model/Challenge';
import { Word } from '../../../../model/Word';
import SpellingItem from '../Items/SpellingItem/SpellingItem';
import styles from './GivenExampleConfirmRemembering.module.scss';

interface GivenExampleConfirmRememberingProps {
    shuffledChoices: { isCorrect: boolean, text: string, wordId: number }[];
    onAnswer: (isCorrect: boolean) => void;
    correctWord: Word;
    challenge: Challenge;
}

const GivenExampleConfirmRemembering = ({ shuffledChoices, onAnswer, correctWord, challenge }: GivenExampleConfirmRememberingProps) => {
    const { HighlightWord } = useSmartWord();

    return (
        <div className={styles.givenExampleConfirmRemembering}>
            <ImageSection word={correctWord!} />
            <h1>{correctWord?.Text}</h1>
            <div className={styles.quote}>❝</div>
            <div className={styles.definition}>
                {HighlightWord(challenge.Question, correctWord?.Text)}
            </div>
            <div className={styles.spellingContainer}>
                {shuffledChoices.map((choice, index) => (
                    <SpellingItem
                        key={index}
                        text={choice.text}
                        isAnswer={choice.isCorrect}
                        index={index}
                        onAnswer={onAnswer}
                        correctWord={correctWord!}
                    />
                ))}
            </div>
        </div>
    );
};

export default GivenExampleConfirmRemembering;